class AmbiencePlayerElement extends HTMLElement {
  connectedCallback() {
    this.audio = this.querySelector("audio");
    this.addEventListener("click", this);
    this.audio.addEventListener("play", this);
    this.audio.addEventListener("pause", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      if (this.audio) {
        if (this.audio.paused) this.audio.play();
        else this.audio.pause();
      }
    } else if (e.type === "play") {
      this.toggleAttribute("playing", true);
    } else if (e.type === "pause") {
      this.toggleAttribute("playing", false);
    }
  }
}

customElements.define("ambience-player", AmbiencePlayerElement);
